<template>
    <div class="interface-inventory" :class="{'disabled': disabled || pending}">
        <header class="interface-inventory__header">
            <img class="img" :src="image">
            <span>{{title}}</span>
        </header>

        <div class="table-wrap">
            <div class="table-header">Обновленная ежемесечная инвентаризация</div>
            <v-data-table
                    class="table"
                    :headers="headers"
                    :items="data"
                    hide-actions>

                <template slot="items" slot-scope="props">
                    <td v-for="(key, i) in keys" :key="i">
                        <span v-if="props.item[key]">{{ props.item[key] }}</span>
                        <span v-else class="input-wrapper">
                            <v-alert
                                    outline
                                    color="warning"
                                    v-model="alert"
                                    dismissible
                                    class="interface-inventory__help"
                            >
                              Поле для ввода данных
                            </v-alert>
                            <input :name="key" @input="update(key, props.item.name, $event.target.value)" type="text"/>
                        </span>
                    </td>
                </template>
            </v-data-table>

        </div>

        <div class="interface-inventory__footer">
            <v-btn :loading="pending" color="warning" @click="onSend">Отправить результаты инвентаризации</v-btn>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            image: String,
            table: Object,
            disabled: Boolean
        },
        data () {
            return {
                alert: true,
                pending: false,
                updates: {}
            }
        },
        computed: {
            headers () {
                return this.table.headers.map(item => {
                    item.sortable = false
                    return item
                })
            },
            data () {
                return this.table.data
            },
            keys () {
                return this.headers.map(item => item.value)
            }
        },
        methods: {
            update (key, name, value) {
                this.alert = false
                this.updates[name] = {
                    [key]: value
                }
            },
            onSend () {
                this.pending = true
                this.$emit('send', this.updates)
            },
            reset () {
                this.pending = false
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .input-wrapper {
        position relative
    }
    .interface-inventory {
        &__help {
            top -85%
            left 110%
            width 14rem
            background #fff
            position absolute
            z-index 10
            font-size 13px
            line-height normal
            margin 0
            padding 6px 6px 6px 8px

            /deep/ .alert__dismissible {
                margin 0
            }

            &::before {
                top 50%
                transform translateY(-10px)
                content ''
                display block
                position absolute
                right 100%
                border 10px solid transparent
                border-right-color #ffc107
            }
        }

        &.disabled {
            pointer-events none
        }

        &__header {
            height 7rem
            position relative
            margin-bottom 4rem
            text-align center
            display flex
            align-items center
            justify-content center
            background-color #ebebeb
            font-size 2rem
            font-weight bold

            img {
                position absolute
                height 9rem
                width auto
                top 0.5rem
                left 0.5rem
            }
        }
        &__footer {
            text-align center
            margin-top 2.5rem
        }
    }
    .table-wrap {
        margin 0 4rem
        border 1px solid #c8c5c8
    }
    .table-header {
        background-color antiquewhite
        text-align center
        font-weight bold
        padding 0.5rem 0
    }
    .table {

        /deep/ thead {
            background-color #ebebeb
        }

        /deep/ thead tr {
            height 35px
        }

        /deep/ th {
            font-weight bold
        }

        /deep/ td {
            height 30px
            border-left 1px solid #c8c5c8
        }

        /deep/ td:first-child {
            border-left 0 none
        }

        /deep/ tr {
            border-color #c8c5c8 !important
        }

        /deep/ tr:hover {
            background-color transparent!important
        }

        /deep/ input {
            outline none
            border 1px solid #c6c6c6
        }
    }

</style>
